
<mat-grid-list rows="2" cols="{{isPhonePortrait ? 1: 2}}" rowHeight="800px" colWidth="49%">
    <mat-grid-tile colspan="1">
    <mat-card
        [ngClass]="selectedClassNameZutrittspunkt1">
        <mat-card-header>
            <mat-card-title>
                @if(istVerbundenZutrittspunkt1 === true){
                <button  mat-icon-button
                    title="{{'TRENNE_VERBINDUNG_LESEINHEIT' | translate}}"
                    (click)="disconnectZutrittspunkt1()"><i class="fa-duotone fa-users-slash"></i></button>
                }
                <mat-form-field class="mat-w-100">
                <mat-label>{{'LESEEINHEIT' | translate}}</mat-label>
                <mat-select panelWidth="auto" title="{{'LESEEINHEIT_AUSWAEHLEN' | translate}}"
                    [(ngModel)]="selectedLeseinheitId1"
                    (ngModelChange)="connectServerSentEventZutrittspunkt1()">
                    @for (zutrittspunkt of zutrittspunkte; track zutrittspunkt) {
                    <mat-option [value]="zutrittspunkt.leseeinheitId">{{zutrittspunkt.zutrittspunktName}} -
                        {{'RICHTUNG' + zutrittspunkt.richtung | translate }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            </mat-card-title>
        </mat-card-header>
        <img mat-card-image src="{{imgSrc1}}" class="profilbild" />
        @if(istVerbundenZutrittspunkt1){
        <mat-card-content>
            @if(personal1 && personal1.Nachname && personal1.Vorname){
                <p>{{personal1.Nachname}} {{personal1.Vorname}}</p>
            }
            @if(personal1 &&personal1.Firmenname){
                <p>{{personal1.Firmenname}}</p>
            }
            @if(personal1 &&personal1.Kartennummer){
                <p>{{personal1.Kartennummer}}</p>
            }
            @if(personal1 &&personal1.Timestamp){
                <p>{{personal1.Timestamp | date: 'dd.MM.YYYY HH:mm'}}</p>
            }
        </mat-card-content>
        }@else if(istVerbundenZutrittspunkt1 === false){
        <mat-card-content>
            <p>{{'GETRENNT' | translate}}</p>
        </mat-card-content>
        }@else {
        <mat-card-content>
            <p>{{'VERBUNDEN' | translate}}</p>
            <p>{{'KEIN_ZUTRITTSEREIGNIS' | translate}}</p>
        </mat-card-content>
        }
    </mat-card>
</mat-grid-tile>
<mat-grid-tile colSpan="1">
    <mat-card
        [ngClass]="selectedClassNameZutrittspunkt2">
        <mat-card-header>
            <mat-card-title>
                @if(istVerbundenZutrittspunkt2 === true){
                <button  mat-icon-button
                    (click)="disconnectZutrittspunkt2()"><i class="fa-duotone fa-users-slash"></i></button>
                }
                    <mat-form-field class="mat-w-100">
                    <mat-label>{{'LESEEINHEIT' | translate}}</mat-label>

                <mat-select panelWidth="auto" title="{{'LESEEINHEIT_AUSWAEHLEN' | translate}}"
                    [(ngModel)]="selectedLeseinheitId2"
                    (ngModelChange)="connectServerSentEventZutrittspunkt2()">
                    @for (zutrittspunkt of zutrittspunkte; track zutrittspunkt) {
                    <mat-option [value]="zutrittspunkt.leseeinheitId">{{zutrittspunkt.zutrittspunktName}} -
                        {{'RICHTUNG' + zutrittspunkt.richtung | translate }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            </mat-card-title>
        </mat-card-header>
        <img mat-card-image src="{{imgSrc2}}" class="profilbild" />
        @if(istVerbundenZutrittspunkt2){
        <mat-card-content>
            @if(personal2 && personal2.Nachname && personal2.Vorname){
                <p>{{personal2.Nachname}} {{personal2.Vorname}}</p>
            }
            @if(personal2 && personal2.Firmenname){
                <p>{{personal2.Firmenname}}</p>
            }
            @if(personal2 && personal2.Kartennummer){
                <p>{{personal2.Kartennummer}}</p>
            }
            @if(personal2 && personal2.Timestamp){
                <p>{{personal2.Timestamp | date: 'dd.MM.YYYY HH:mm'}}</p>
            }
        </mat-card-content>
        }@else if(istVerbundenZutrittspunkt2 === false){
        <mat-card-content>
            <p>{{'GETRENNT' | translate}}</p>
        </mat-card-content>
        }
    </mat-card>
</mat-grid-tile>
</mat-grid-list>